<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg897"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs901"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath911"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path909" /></clipPath></defs><g
     id="g903"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g905"><g
         id="g907"
         clip-path="url(#clipPath911)"><g
           id="g913"
           transform="translate(246,462.0005)"><path
             d="m 0,0 h 20 c 5.5,0 10,-4.5 10,-10 v -20 h 20 c 5.5,0 10,-4.5 10,-10 v -20 c 0,-5.5 -4.5,-10 -10,-10 H 30 v -20 c 0,-5.5 -4.5,-10 -10,-10 H 0 c -5.5,0 -10,4.5 -10,10 v 20 h -20 c -5.5,0 -10,4.5 -10,10 v 20 c 0,5.5 4.5,10 10,10 h 20 v 20 c 0,5.5 4.5,10 10,10 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path915" /></g><g
           id="g917"
           transform="translate(256.0005,322.0005)"><path
             d="M 0,0 C 49.57,0 90,40.43 90,90 90,139.57 49.57,180 0,180 -49.57,180 -90,139.57 -90,90 -90,40.43 -49.57,0 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path919" /></g><g
           id="g921"
           transform="translate(166.5464,392.0005)"><path
             d="M 0,0 H -120.546 V 40 H 0 m 179.282,0 H 299.454 V 0 H 179.282"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path923" /></g><path
           d="m 36,10.001 h 440 v 40 H 36 Z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
           id="path925" /><g
           id="g927"
           transform="translate(46,60.001)"><path
             d="M 0,0 V 30 H 420 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path929" /></g><g
           id="g931"
           transform="translate(66.0005,343.1895)"><path
             d="M 0,0 V 44.06 M 0,-248.438 V -90"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path933" /></g><g
           id="g935"
           transform="translate(445.999,387.2495)"><path
             d="M 0,0 V -292.498"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path937" /></g><g
           id="g939"
           transform="translate(355.999,100.001)"><path
             d="m 0,0 v 171.999 c 0,5.5 -4.501,9.999 -10,9.999 h -179.999 c -5.499,0 -10,-4.501 -10,-9.999 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path941" /></g><g
           id="g943"
           transform="translate(256,271.999)"><path
             d="M 0,0 V -171.998"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path945" /></g><g
           id="g947"
           transform="translate(215.9985,195.9995)"><path
             d="M 0,0 V -20"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path949" /></g><g
           id="g951"
           transform="translate(296.0015,195.9995)"><path
             d="M 0,0 V -20"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.926;stroke-dasharray:none;stroke-opacity:1"
             id="path953" /></g><g
           id="g955"
           transform="translate(66.0005,298.1934)"><path
             d="M 0,0 V -0.007"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:2.613;stroke-dasharray:none;stroke-opacity:1"
             id="path957" /></g></g></g></g></svg>
</template>
